import React from 'react';
export function Header() {
  return <header className="fixed top-0 left-0 right-0 z-50 bg-navy/80 backdrop-blur-md border-b border-primary/10" data-id="element-67">
      <div className="max-w-7xl mx-auto px-6 h-24 flex items-center justify-between" data-id="element-68">
        <div className="flex items-center" data-id="element-69">
          <img src="https://cdn.magicpatterns.com/uploads/41yMwo1fNJJmW99NgWfnB6/Logo_New_Coneckta.png" alt="CONECKTA" className="h-12 w-auto object-contain" style={{
          width: '160px',
          height: '48px'
        }} data-id="element-70" />
        </div>
        <a href="https://wa.link/cesnp8" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-gradient-to-r from-[#00B4D8] to-[#0077B6] text-white font-semibold rounded-full px-6 py-2.5 text-sm transition-all duration-300 hover:shadow-[0_0_15px_rgba(0,180,216,0.4)] hover:scale-[1.02] active:scale-[0.98]" data-id="element-71">
          Agenda tu llamada gratis
        </a>
      </div>
    </header>;
}